import React from "react";
import styles from "./styles.module.css";
import MultiLanguageTranslation from "../../_components/Translate/MultiLangTranslate";
var quotes = [
  {
    quote:
      "To forget how to dig the earth and to tend the soil is to forget ourselves",
    author: "Mahatma Gandhi",
  },
  { quote: "The farm is part of me", author: "Erich Wehrenberg" },
  {
    quote: "A fertile soil alone does not carry agriculture to perfection",
    author: "EH Darby",
  },
];
var quote = quotes[Math.floor(Math.random() * quotes.length)];
export default class Quote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
    };
  }
  async componentDidMount() {
    let lang = localStorage.getItem("lang");
    this.setState({
      lang: lang,
    });
    this.hindiQuote = {
      "Mahatma Gandhi": "महात्मा गांधी",
      "Erich Wehrenberg": "एरिक वेरेनबर्ग",
      "EH Darby": "ई.एच डार्बी",
      "To forget how to dig the earth and to tend the soil is to forget ourselves":
        "यह भूल जाना कि मिट्टी को कैसे खोदना है और मिट्टी की देखभाल कैसे करनी है, स्वयं को भूल जाने जैसा है",
      "The farm is part of me": "खेती मेरे जीवन का अहम हिस्सा है",
      "A fertile soil alone does not carry agriculture to perfection":
        "सिर्फ उपजाऊ जमीन मात्र खेती को पूर्णता नहीं प्रदान कर सकती",
    };
  }
  render() {
    return (
      <span
        className={`${styles["loader-style"]}`}
        // id="loader-quote"
        // style={{
        //   fontWeight: 400,
        //   lineHeight: "1.6em",
        //   fontFamily: "Roboto",
        //   fontSize: 16,
        // }}
      >
        “
        {this.state.lang === "hindi"
          ? this.hindiQuote[quote.quote]
          : quote.quote}
        .”
        <span id="quote-author">
          ~
          {this.state.lang === "hindi"
            ? this.hindiQuote[quote.author]
            : quote.author}
        </span>
      </span>
    );
  }
}
